import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Text_Transformation = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🔤 CSS Text Transformation</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>text-transform</code> property in CSS controls the
        capitalization of text. It can transform text to{" "}
        <strong>uppercase</strong>, <strong>lowercase</strong>, or{" "}
        <strong>capitalize</strong>.
      </p>

      {/* Uppercase */}
      <div className="tutorial-section">
        <h2 className="section-title">Uppercase</h2>
        <p>Converts all characters to uppercase.</p>
        <CodeCopyBlock
          code={`p {
  text-transform: uppercase;
}`}
        />
        <p
          style={{
            textTransform: "uppercase",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          this text is transformed into uppercase
        </p>
      </div>

      {/* Lowercase */}
      <div className="tutorial-section">
        <h2 className="section-title">Lowercase</h2>
        <p>Converts all characters to lowercase.</p>
        <CodeCopyBlock
          code={`p {
  text-transform: lowercase;
}`}
        />
        <p
          style={{
            textTransform: "lowercase",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          THIS TEXT IS TRANSFORMED INTO LOWERCASE
        </p>
      </div>

      {/* Capitalize */}
      <div className="tutorial-section">
        <h2 className="section-title">Capitalize</h2>
        <p>Makes the first letter of each word uppercase.</p>
        <CodeCopyBlock
          code={`p {
  text-transform: capitalize;
}`}
        />
        <p
          style={{
            textTransform: "capitalize",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          this text is transformed into capitalize
        </p>
      </div>

      {/* None */}
      <div className="tutorial-section">
        <h2 className="section-title">None (Default)</h2>
        <p>Leaves the text as it is (default setting).</p>
        <CodeCopyBlock
          code={`p {
  text-transform: none;
}`}
        />
        <p
          style={{
            textTransform: "none",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This Text Stays As It Is
        </p>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After learning transformations, check out{" "}
          <a href="/css/text-spacing" className="learn-more">
            CSS Text Spacing
          </a>{" "}
          to learn how to adjust letter, word, and line spacing for better
          readability.
        </p>
      </div>
    </div>
  );
};

export default Text_Transformation;
